export const googleApiConfig = {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope:
    "https://www.googleapis.com/auth/business.manage https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
  reCaptchaSiteKey: "6Ldr_9sUAAAAAM2go5PfjujnyZHIdHf_VTEtxVyF",
  reCaptchaSiteKeyTesting: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" //https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do
};
